export enum CurrentFlow {
  V1 = 'V1',
  OpenDDA = 'OPEN DDA',
  MissedPayment = 'MISSED PAYMENT',
  FinancialCheckup = 'FINANCIAL CHECKUP',
  Card = 'CARD',
}
